import { defineComponent as _defineComponent } from 'vue'
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import FpTooltip from '@/components/fpComponents/FpTooltip.vue';
import {LoanPurposeActivity} from '@/models/simulation/LoanPurposeActivity';
import {LoanPurposeWhat} from '@/models/simulation/LoanPurposeWhat';
import {computed, ref, watchEffect} from 'vue';
import AlertMessage from '@/components/commons/message/AlertMessage.vue';
import {AlertType} from '@/models/enums/AlertType';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeStartProgramForm',
  props: {
    isFormValid: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({
  isFormValidChange: [value: boolean]
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isFormValid: boolean
}


const store = useSimulationStore()

const activitesWithLimits = [LoanPurposeActivity.BUYING, LoanPurposeActivity.BUYING_AND_RENOVATING,];
const whatWithLimits = [LoanPurposeWhat.APARTMENT, LoanPurposeWhat.HOUSE,];
const correctActivities = [LoanPurposeActivity.BUYING,
  LoanPurposeActivity.BUYING_AND_RENOVATING,
  LoanPurposeActivity.BUILDING,
  LoanPurposeActivity.BUYING_PLOT_AND_BUILDING,];
const correctWhats = [LoanPurposeWhat.APARTMENT, LoanPurposeWhat.HOUSE, LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE,];
const correctCollaterals = [LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE,];

const previousArea = ref<Nullable<number>>(null);

const shouldShowLimitInfo = computed(() => {
  return whatWithLimits.includes(store.userInput?.loanPurpose?.what!) && activitesWithLimits.includes(store.userInput?.loanPurpose?.activity!)
})

const isLoanPurposeHouse = computed(() => {
  return store.userInput?.loanPurpose?.what === LoanPurposeWhat.HOUSE
})

const shouldHideAreaInput = computed(() => {
  return (store.userInput?.loanPurpose?.what === LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE &&
    store.userInput?.loanPurpose?.activity === LoanPurposeActivity.BUYING_PLOT_AND_BUILDING) ||
    (store.userInput?.loanPurpose?.what === LoanPurposeWhat.HOUSE &&
      store.userInput?.loanPurpose?.activity === LoanPurposeActivity.BUILDING) ||
    (store.userInput?.loanPurpose.activity === LoanPurposeActivity.BUYING_PLOT_AND_BUILDING &&
      store.userInput?.collateral === LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE)
})
const isLoanPurposeWhatCorrect = computed(() => {
  return store.userInput?.loanPurpose.what !== null && correctWhats.includes(store.userInput?.loanPurpose?.what!)
})
const isLoanPurposeActivityCorrect = computed(() => {
  return correctActivities.includes(store.userInput?.loanPurpose?.activity!)
})

const isCorrectCollateralAndActivity = computed(() => {
  return store.userInput?.collateral === LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE &&
    store.userInput.loanPurpose.activity === LoanPurposeActivity.BUYING_PLOT_AND_BUILDING
})

const isNotAvailableForHomeStartProgram = computed(() => {
  if (store.userInput?.loanPurpose.activity === LoanPurposeActivity.BUYING_PLOT_AND_BUILDING) return !isCorrectCollateralAndActivity.value
  return !isLoanPurposeWhatCorrect.value || !isLoanPurposeActivityCorrect.value
})
const isAvailableForHomeStartProgram = computed(() => {
  return !isNotAvailableForHomeStartProgram.value
})
watchEffect(() => {
  if (isNotAvailableForHomeStartProgram.value) {
    store.setIsHomeStartFormHidden(true)
    return
  }
  store.setIsHomeStartFormHidden(false)
  if (shouldHideAreaInput.value) {
    store.userInput!.homeStartProgramInput!.isBuildingHouse = true;
    if (store.userInput!.homeStartProgramInput!.propertyArea !== null) previousArea.value = store.userInput!.homeStartProgramInput!.propertyArea;
    store.userInput!.homeStartProgramInput!.propertyArea = null;
  } else {
    store.userInput!.homeStartProgramInput!.isBuildingHouse = false;
    if (previousArea.value !== null) {
      store.userInput!.homeStartProgramInput!.propertyArea = previousArea.value;
    }
  }
})




return { __sfc: true,props, store, activitesWithLimits, whatWithLimits, correctActivities, correctWhats, correctCollaterals, previousArea, shouldShowLimitInfo, isLoanPurposeHouse, shouldHideAreaInput, isLoanPurposeWhatCorrect, isLoanPurposeActivityCorrect, isCorrectCollateralAndActivity, isNotAvailableForHomeStartProgram, isAvailableForHomeStartProgram, emit, FpTooltip, AlertMessage, AlertType }
}

})